/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import State from './State';

/**
 * The City model module.
 * @module model/City
 * @version 1.0.0
 */
class City {
    /**
     * Constructs a new <code>City</code>.
     * @alias module:model/City
     * @param id {Number} 
     * @param name {String} 
     * @param state {module:model/State} 
     */
    constructor(id, name, state) { 
        
        City.initialize(this, id, name, state);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, state) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['state'] = state;
    }

    /**
     * Constructs a <code>City</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/City} obj Optional instance to populate.
     * @return {module:model/City} The populated <code>City</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new City();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('state')) {
                obj['state'] = State.constructFromObject(data['state']);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
City.prototype['id'] = undefined;

/**
 * @member {String} name
 */
City.prototype['name'] = undefined;

/**
 * @member {module:model/State} state
 */
City.prototype['state'] = undefined;






export default City;

